export default "__VITE_ASSET__DkR7V0$L__"